(function() {
    angular.module('tmx-app').controller('usersCtrl', ['resolvedData','$scope', '$state', '$mdDialog', 'UsersService',
        '$mdSidenav','CurrentUserService','TmxDialogService','tmxUtility','populateDate','menu', 
    
        function UsersCtrl(resolvedData,$scope, $state, $mdDialog, UsersService, $mdSidenav,CurrentUserService,
            TmxDialogService,tmxUtility,populateDate,menu) {
            var userVM = this;
            var exists;
            var copy;
            exists = tmxUtility.exists;
            copy = tmxUtility.copy;
            userVM.EntityName = "Users";
            userVM.isPageLoading = false;
      ///////////////////////// CHECKING PRIVILEGES OF THIS ENTITY///////////////////////////////////////////////////////
            userVM.menu = menu;
            userVM.Privileges = [];
            userVM.ViewPrivilege = false;
            userVM.EditPrivilege = false;
            userVM.DeletePrivilege = false;
            userVM.AddPrivilege = false;
            userVM.checkPermission = tmxUtility.checkPermission;
       

            (function initializePrevileges(){
                userVM.ViewPrivilege = userVM.checkPermission('Private.Administration.Users','View');
                userVM.EditPrivilege = userVM.checkPermission('Private.Administration.Users','Edit');
                userVM.DeletePrivilege = userVM.checkPermission('Private.Administration.Users','Delete');
                userVM.AddPrivilege = userVM.checkPermission('Private.Administration.Users','Create');
            })();

            userVM.getMenu = function() {
                if(angular.isDefined(menu.pages.sections)){
                    for(var i=0;i<menu.pages.sections.length;i++){
                        var section = menu.pages.sections[i];
                        if(angular.isDefined(section.pages) && section.pages != null && section.pages.length>0){
                            for(var j=0;j<section.pages.length;j++){
                                if(section.pages[j].name ==  userVM.EntityName){
                                    return section.pages[j];
                                }
                            }
                        }
                    }
                }
                return undefined;
            };
            userVM.menuChanged = function(newMenuSection) {
           
                if(!angular.isDefined(newMenuSection)){return;}
                userVM.customerMenuSection = newMenuSection;//sections in the menu

            };
            $scope.$watch(userVM.getMenu, userVM.menuChanged,true);
    ///////////////////FUNCTIONS////////////////////////
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            userVM.checkAddDisabled = function(){
                if($mdSidenav(userVM.nav).isOpen()){
                    return true;
                }
                else{
                    return false;
                }
            };
            userVM.formatPhoneNumber=function(dataitem){
                if(angular.isDefined(dataitem) && dataitem!=null) {
                    return "+"+dataitem;
                }
                return "";
            }

            userVM.isFiltered=function(fieldName){
                var filtered = false;
                if(fieldName=="Status"){
                    fieldName="EffectiveEndDate";
                }
                if(angular.isDefined(userVM.filters)) {
                    userVM.filters.filters.forEach(function(filter){
                        if(filter.field==fieldName) {filtered = true;}
                        else if(filter.field=="EffectiveStartDate" && fieldName=="EffectiveEndDate") {
                            filtered = true;
                        }
                    });
                }
                return filtered;
            }

            userVM.getDevicePhoneNumber= function(deviceId){
                for(var i=0;i<userVM.Devices.length;i++) {
                    if(userVM.Devices[i].HiddenValue==deviceId)
                        return userVM.Devices[i].PhoneNumber;
                }
                return " ";
            }

            userVM.getUserType = function(dataitem) {
       
                if (angular.isDefined(UsersService.type) && UsersService.type.length > 0) {
                    for (var i = UsersService.type.length - 1; i >= 0; i--) {
                        if (UsersService.type[i].LookupId == dataitem) {
                            return UsersService.type[i].VisibleValue;
                        }
                    }
                }
                return "N/A";
            };

            userVM.statusBackgroundColor=function(dataitem){
                var result= tmxUtility.SetStatusBackgroundColor(dataitem.Status);
                return result;           
            };

            userVM.getDesignation = function(dataitem) {
       
                if (angular.isDefined(dataitem.Designation) && dataitem.Designation!=null && dataitem.Designation!="") {
                    if(angular.isDefined(UsersService.desigs) && UsersService.desigs.length>0) {
                        for (var i = UsersService.desigs.length - 1; i >= 0; i--) {
                            if (UsersService.desigs[i].HiddenValue == dataitem.Designation) {
                                return UsersService.desigs[i].VisibleValue;
                            }
                        }
                    }
                }
                return "N/A";
            };
            userVM.currentTenant=CurrentUserService.getUserObject();
            userVM.getStatus = function(dataitem) {


                if (dataitem=="Active") {
                    return "Active";
                }
                else if(dataitem=="Pending"){
                    return "Pending";
                }
                else{
                    return "Inactive";
                }
            };

            userVM.isEditable=function(dataitem){
                if(dataitem=="Active" || dataitem=="Pending" ){
                    return true;
                }
                return false;
            }

            userVM.reload = function() {
                userVM.container.userGrid.dataSource.read();
            };

            userVM.success=function(promise){
                if(promise.read==true) {
                    userVM.container.userGrid.dataSource.transport.read(promise);
                }
                else {
                    userVM.container.userGrid.dataSource.read(); 
                }
                userVM.toggleSearch(userVM.nav);
            };

            userVM.onChildState = function() {
                if ($state.current.name.indexOf(".add") > 0 || $state.current.name.indexOf(".edit") > 0) return true;
            };

            userVM.new = function() {
                $state.data.info = false;
                $state.go($state.current.name + ".add");
            };

            userVM.clickEdit = function(item) {
                $state.data.info = false;
                $state.go($state.current.name + ".edit", {
                    "Id": item.UserID
                });
            };

            userVM.clickView = function (item) {   
                $state.data.info = true;         
                $state.go($state.current.name+".edit",{"Id":item.UserID});
            }     

            userVM.formatFirstName = function(item) {

                return item.FirstName;
            };

            userVM.formatLastName = function(item) {
                return item.LastName;
            };

            userVM.formatName = function(item) {
                return item.FirstName + ' ' + (item.MiddleName ? item.MiddleName + ' ' : '') + item.LastName;
            };

            userVM.clickCopy = function(e) {
                $mdDialog.show({
                    clickOutsideToClose: true,
                    controller: function($mdDialog) {
                        var vm = this;
                        vm.clone = userVM.clone;
          // vm.task = task;  //your task object from the ng-repeat
                        $scope.hide = function() {
                            $mdDialog.hide();
                        };
                        $scope.cancel = function() {
                            $mdDialog.cancel();
                        };
                    },
                    controllerAs: 'modal',
                    templateUrl: 'app/private/clone.html',
                    parent: angular.element(document.body),
                    targetEvent: e
                });
            }
            var deleteConfirm = function(tid) {
                var confirm = $mdDialog.confirm()
                    .title('Delete Company ' + tid.CompanyName + " ?")
                    .textContent('Are you sure you want to delete this company?')
                    .ariaLabel('Lucky day')
                    .clickOutsideToClose(true)
        // .targetEvent(ev)
                    .ok('Yes')
                    .cancel('Cancel');
                $mdDialog.show(confirm).then(function() {
                    DeleteCompany(tid);
                }, function() {
                });
            };
            var DeleteCompany = function(tid) {
                tid.$remove().then(function() {
                    userVM.container.userGrid.dataSource.read();
                });
            };
            userVM.clickDelete = function(item) {
                deleteConfirm(item);
            };
    // userVM.clickDeactivate = function(item) {
    //   item.$deactivate(item.UserId).then(function(promise) {
    //     userVM.container.userGrid.dataSource.read();
    //   });
    // };
    // userVM.clickActivate = function(item) {
    //   item.$activate(item.UserId).then(function(promise) {
    //     userVM.container.userGrid.dataSource.read();
    //   });
    // };
            userVM.clickDeactivate = function(item) {

                var diagConfig={
                    action:"Deactivate",
                    entity:"User",
                    entityname:item.UserName,
                    details:[
                        {value:item.UserName,label:"User Name"},
                        {value:userVM.getStatus(item.Status), label:"Status"}
                    ],
                    options:[
                        {label:"Deactivate",value:true,class:"md-warn"},
                        {label:"Cancel",value:false,class:"md-primary"}
                    ]
                };
                function callback(ok) {
                    if(ok){
                        userVM.Deactivate(item);
                    }
                }
                var userDeactivateDialog=new TmxDialogService.confirmDialog(diagConfig,callback);

                userDeactivateDialog.show();
      //}
            };
            userVM.clickActivate = function(item) {
    //  var confirm = $mdDialog.confirm()
    //  .title('Activate User '+item.UserName+" ?")
    //  .textContent('Are you sure you want to activate this User?')
    //  .ariaLabel('Activate User')
    //  .clickOutsideToClose(true)
    //  .ok('Yes')
    //  .cancel('Cancel');
    //  $mdDialog.show(confirm).then(
    //    function() {
    //    userVM.Activate(item);
    //    }, function() {
    //    }
    //  );
                var diagConfig={
                    action:"Activate",
                    entity:"User",
                    entityname:item.UserName,
                    details:[
                        {value:item.UserName,label:"User Name"},
                        {value:userVM.getStatus(item.Status), label:"Status"}
                    ],
                    options:[
                        {label:"Activate",value:true,class:"md-warn"},
                        {label:"Cancel",value:false,class:"md-primary"}
                    ]
                };
                function callback(ok) {
                    if(ok){
                        userVM.Activate(item);
                    }
                }
                var userActivateDialog=new TmxDialogService.confirmDialog(diagConfig,callback);

                userActivateDialog.show();
            };
            userVM.Deactivate = function(item) {
                item.$deactivate(item.UserID).then(function() {
                    userVM.container.userGrid.dataSource.read();
                });
            };
            userVM.Activate = function(item) {
                item.$activate(item.UserID).then(function() {
                    userVM.container.userGrid.dataSource.read();
                });
            };
            userVM.isStatusActive=function(dataitem) {
       
                if (userVM.getStatus(dataitem) == "Active")
                    return true;
                else
                    return false;
            };

            userVM.isStatusPending=function(dataitem) {
           
                if (userVM.getStatus(dataitem) == "Pending")
                    return true;
                else
                    return false;
            };

            userVM.onClick = function(e, dataItem) {
                var element = $(e.currentTarget);
                var checked = element.is(':checked');
                var row = element.closest("tr");
                if (checked) {
                    row.addClass("k-state-selected");
                    userVM.addToBulk(dataItem);
                }
                else {
                    row.removeClass("k-state-selected");
                    userVM.removeFromBulk(dataItem);
                }
            };
            userVM.addToBulk = function(dataItem) {
                userVM.bulk.push(dataItem);
            };
            userVM.removeFromBulk = function(dataItem) {
                for (var i = userVM.bulk.length - 1; i >= 0; i--) {
                    if (userVM.bulk[i].CompanyId === dataItem.CompanyId) {
                        userVM.bulk.splice(i, 1);
                    }
                }
            };
            userVM.bulkDelete = function() {
                var confirm = $mdDialog.confirm()
                    .title('Bulk Delete')
                    .textContent('Are you sure you want to delete ' + userVM.bulk.length + ' companies?')
                    .ariaLabel('Lucky day')
                    .clickOutsideToClose(true)
        // .targetEvent(ev)
                    .ok('Yes')
                    .cancel('Cancel');
                $mdDialog.show(confirm).then(function() {
                    UsersService.bulkDelete(userVM.bulk);
                }, function() {
                });
            };
            userVM.toggleSearch = function() {
                if (userVM.searchSideNavActive) {
        // userVM.searchData = {};
                    userVM.searchSideNavActive = false;
                }
                else
                    userVM.searchSideNavActive = true;
                userVM.toggle('SearchSideNav');
            }
            userVM.toggleExport = function() {
                if (userVM.exportSideNavActive)
                    userVM.exportSideNavActive = false;
                else
                    userVM.exportSideNavActive = true;
                userVM.toggle('ExportSideNav');
            }
            userVM.isOpen = function(navID) {
                return $mdSidenav(navID).isOpen();
            };
            userVM.toggle = function(navID) {
                $mdSidenav(navID)
                    .toggle()
                    .then(function() {});
            };
            userVM.search = function(navID) {
                let calls = [];
                for (var key in userVM.searchData) {
                    if (userVM.searchData.hasOwnProperty(key)) {
                        calls.push({
                            field: key,
                            operator: "contains",
                            value: userVM.searchData[key]
                        });
                    }
                }
                userVM.filt = {
                    filters: calls,
                    logic: "and"
                };
                userVM.o.data.filter = userVM.filt;
  
                userVM.container.userGrid.dataSource.transport.read(userVM.o);
                userVM.toggle(navID);
            };
            userVM.clear = function(navID) {
                userVM.toggle(navID);
            };
            userVM.clearSideNav = function() {
                userVM.searchData = {};
            };
    ////////////////////////////////////////////////////

    
    //////////////////////CODE//////////////////////////
            userVM.query = "User"
            userVM.UsersService = UsersService;
            userVM.cols = UsersService.gridColumn;
            userVM.nav = "SearchSideNav";
            userVM.schema = UsersService.schema;
            userVM.Devices = resolvedData.Devices.data;
            userVM.date = (populateDate.setStartDateObject(new Date())).toJSON();//new Date().toJSON();
            userVM.gridData = new kendo.data.ObservableArray([]);
            userVM.cloneColumn = angular.copy(UsersService.GetUserGridColumns());
            userVM.clone = 0;
            userVM.dataObj = {
                value: "empty"
            };
            userVM.gridColumns = angular.copy(UsersService.columns);    
            userVM.mainGridOptions = {
                dataSource: {
                    transport: {
                        read: function(o) {
                            if(angular.isDefined(userVM.searchClear) && userVM.searchClear==false){
                                if(exists(userVM.o)){

                                    if(exists( o.data.filter)){
                                        var findIndex=o.data.filter.filters.find(x=>x.field=="BranchName");
                                        if(exists(findIndex)){
                                            findIndex.field="CompanyBranchId"
                                        }
                                    }


                                    copy(userVM.o.data,["filter"],o.data);
                                }
                            }
                            userVM.searchClear = false;
                            if(userVM.onChildState()){return;}
                            if(!o.fromSideNav) {
                                if($state.searchClear){
                                    userVM.searchClear = true;
                                    $state.searchClear=undefined;
                                }

                            }
                            else
                                o.data.firstPage = true;
                            userVM.o = angular.copy(o);
                            if(userVM.o.data.firstPage){
                                selected();
                            }
                            userVM.filters = userVM.o.data.filter;
                            userVM.isPageLoading = true;
                            UsersService.getByParams(o, true).then(function(response) {
                                parseResppnse(response.data);
                                userVM.exportData=response;
                                o.success(response);
                                userVM.isPageLoading = false;
                            });
                        },
                        dataType: "json"
                    },
                    schema: {
                        data: "data",
                        total: "Total"
                    },
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,

                    sort:  [{field: "CreatedDate", dir: "desc"}],
                },
                excelExport: function(e) {                                         
                    var sheet = e.workbook.sheets[0];
                    var data = userVM.exportData.data;
                    var gridColumns = userVM.container.userGrid.columns;                    
                    var columns = tmxUtility.columnsMapping(gridColumns);    
                    data=setLookupValue(data);
                    var rows=tmxUtility.dataMapping(data,columns);                        
                    sheet.rows = rows;  
                },
                pageable: {
                    refresh: true,
                    pageSizes: true,
                    pageSize: 10,
                    buttonCount: 5
                },
                pdf: {
                    allPages: true,
                    fileName: "Users.pdf"
                },
                excel: {                    
                    fileName: "Users.xlsx"
                },
                sortable: true,
                scrollable: false,
                columns: userVM.gridColumns
            };
   //////////////////////////////////////////////
            userVM.bulk = [];
            userVM.container = {};
            $state.data = {
                grid: userVM.container
            };
            userVM.searchSideNavActive = false;
            userVM.exportSideNavActive = false;
            userVM.filt = {};
//////////////////////////////////////////////////
            function selected() {
                var dataSource =  userVM.container.userGrid.dataSource;
                if(angular.isDefined(userVM.o) && angular.isDefined(dataSource) &&
            userVM.o.data.firstPage && dataSource.page() != 1) {//implies data loaded into grid is just the firt page data
                    dataSource.page(1);
                }
            }


            function setLookupValue(data){
                for (var i = 0; i < data.length; i++){                    
                    if(exists(data[i].UserTypeLkpID)){
                        var userType=UsersService.type.filter(x=>x.LookupId==data[i].UserTypeLkpID)[0];
                        data[i].UserTypeLkpID=userType.VisibleValue;
                    }
                }
                return data;
            }

            function parseResppnse(data){
                data.forEach(function(dataItem){                                        
                    dataItem.editable = userVM.isEditable(dataItem.Status);   
                    dataItem.Name=userVM.formatName(dataItem);     
                    dataItem.StatusBKColor=tmxUtility.SetStatusBackgroundColor(dataItem.Status);        
                    dataItem.PhoneNumber1 = userVM.formatPhoneNumber(dataItem.PhoneNumber1);  
                    dataItem.statusActive=userVM.isStatusActive(dataItem.Status);  
                    dataItem.statusPending=userVM.isStatusPending(dataItem.Status);
                    dataItem.userType=userVM.getUserType(dataItem.UserTypeLkpID);                    
                });
            }
   ////////////////////////////////////////////////////
        }]);
})();
